import React from 'react';
import { Box, Typography, styled } from '@mui/material';

type StatusType = 'saudavel' | 'protegido' | 'atencao' | 'critico' | 'concluido' | 'falha' | 'pendente' | string;

interface StatusBadgeProps {
  status?: StatusType;
  label?: string;
}

const BadgeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'statusColor',
})<{ statusColor: { bg: string; text: string; border: string } }>(({ statusColor }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '4px 12px',
  borderRadius: '16px',
  backgroundColor: statusColor.bg,
  color: statusColor.text,
  border: `1px solid ${statusColor.border}`,
  fontWeight: 600,
  fontSize: '0.75rem',
}));

const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'dotColor',
})<{ dotColor: string }>(({ dotColor }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: dotColor,
  marginRight: 8,
}));

const getColors = (status: StatusType = '') => {
  const norm = status.toLowerCase();
  if (norm === 'saudavel' || norm === 'protegido' || norm === 'concluido') {
    return { bg: 'rgba(16, 185, 129, 0.1)', text: '#10B981', border: 'rgba(16, 185, 129, 0.2)', dot: '#10B981' };
  }
  if (norm === 'atencao' || norm === 'parcial' || norm === 'pendente') {
    return { bg: 'rgba(245, 158, 11, 0.1)', text: '#F59E0B', border: 'rgba(245, 158, 11, 0.2)', dot: '#F59E0B' };
  }
  if (norm === 'critico' || norm === 'falha') {
    return { bg: 'rgba(239, 68, 68, 0.1)', text: '#EF4444', border: 'rgba(239, 68, 68, 0.2)', dot: '#EF4444' };
  }
  return { bg: 'rgba(100, 116, 139, 0.1)', text: '#94A3B8', border: 'rgba(100, 116, 139, 0.2)', dot: '#94A3B8' };
};

const getLabel = (status: StatusType = '') => {
  const norm = status.toLowerCase();
  if (norm === 'saudavel' || norm === 'protegido') return 'Protegido';
  if (norm === 'concluido') return 'Concluído';
  if (norm === 'atencao') return 'Atenção';
  if (norm === 'critico') return 'Crítico';
  if (norm === 'falha') return 'Falhou';
  return status || 'Desconhecido';
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status = 'desconhecido', label }) => {
  const colors = getColors(status);
  const displayLabel = label || getLabel(status);

  return (
    <BadgeContainer statusColor={colors}>
      <Dot dotColor={colors.dot} />
      <Typography variant="caption" sx={{ fontWeight: 600, color: colors.text }}>
        {displayLabel}
      </Typography>
    </BadgeContainer>
  );
};

export default StatusBadge;
